import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getBroadcastDetails } from "../api/getBroadcastDetails";

type PropsQuery = {
  broadcastId: string;
};

export const useBroadcastDetailsQuery = ({ broadcastId }: PropsQuery) => {
  return useQuery({
    queryKey: ["broadcastDetails", broadcastId],
    queryFn: async () => {
      return await getBroadcastDetails(broadcastId);
    },
    enabled: !!broadcastId,
  });
};

export const invalidateBroadcastDetailsQuery = (broadcastId: string) => {
  return queryClient.invalidateQueries({
    queryKey: ["broadcastDetails", broadcastId],
  });
};
